import { Component, OnInit, ChangeDetectionStrategy, Input, OnChanges, SimpleChanges, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-retroalimentacion-grid-classroom-estado',
  standalone: false,
  templateUrl: './retroalimentacion-grid-classroom-estado.component.html',
  styleUrls: ['./retroalimentacion-grid-classroom-estado.component.scss']
})
export class RetroalimentacionGridClassroomEstadoComponent implements OnInit, OnDestroy, OnChanges {

  @Input()
  submission: any;

  @Input()
  alumno$: Observable<any>;

  @Input()
  devuelto: boolean;

  estados = [{
    key: 'NEW', value: 'Asignada'
  }, {
    key: 'CREATED', value: 'Asignada'
  }, {
    key: 'TURNED_IN', value: 'Entregada'
  }, {
    key: 'RETURNED', value: 'Publicada'
  }, {
    key: 'RECLAIMED_BY_STUDENT', value: 'Asignada'
  }];

  estado: any;
  estadoDeEntrega: string;

  alumnoSubscription: Subscription;

  constructor() { }

  ngOnInit(): void {
    this.modificaciones();
  }

  modificaciones() {
    this.estadoDeEntrega = this.devuelto ? 'Publicada' : 'Asignada'
    // Cuando se implemente classroom
    // if (this.submission) {
    //   this.setEstado();
    // } else {
    // }
  }

  setEstado() {
    this.estado = this.estados.find(item => item.key === this.submission.state);
    if (this.estado) {
      this.estadoDeEntrega = this.estado.key === 'RETURNED' ?
        (this.submission.assignedGrade !== null ?  'Calificada' : this.estado.value) : this.estado.value;
    } else {
      this.estadoDeEntrega = '';
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.devuelto && changes.devuelto.firstChange === false) || (changes.submission && changes.submission.firstChange === false)) {
      this.modificaciones();
    }
  }

  ngOnDestroy(): void {
    if (this.alumnoSubscription) {
      this.alumnoSubscription.unsubscribe();
    }
  }

}
